<script>
  import { getContext } from "svelte";
  import { px } from "../../../utils";

  const { data, rGet } = getContext("LayerCake");

  const XPADDING = 5;
  const leftAligned = ['SIG Sauer'];

  export let color;
  export let projection;

  let europeanManufacturers = $data.features
    .filter(({ properties }) => (properties.name === 'Glock' || properties.name === 'SIG Sauer' || properties.name === 'Colt' || properties.name === 'Beretta' ));
  
  const whichAligned = ({ country, name }) => country === 'US' && leftAligned.includes(name) ? 'end' : 'start';
</script>

{#each europeanManufacturers as { geometry, id, properties } (id)}
  <g
    transform={`translate(${projection(geometry.coordinates)[0]}, ${projection(geometry.coordinates)[1]})`}
  >
    <text 
      fill={color}
      class="map-label"
      x={($rGet(properties) + XPADDING) * (whichAligned(properties) === 'start' ? 1 : -1 )}
      style:text-anchor={whichAligned(properties)}
    >
      {properties.name}
    </text>
  </g>
{/each}

<style lang="scss">
  .map-label {
    dominant-baseline: central;
    font-size: 16px;
    paint-order: stroke;
    stroke: #000000;
    stroke-width: 1.5px;

    @media (max-width: $breakpoint-mobile) {
			font-size: 14px;
		}

    
  }

</style>
